// extracted by mini-css-extract-plugin
module.exports = {"vertical_content_container":"VerticalAlertContent_vertical_content_container__2BbFe"};